import axios from 'axios'
import { api, consts } from "@config"

export function refreshToken(url, method = 'GET', data = {}, successPayload = () => { }, errorPayload = () => { }) {
	axios.post(api.auth.refreshToken, {
		refresh: window.localStorage.getItem(consts.REFRESH_TOKEN)
	})
		.then(resp => {

			window.localStorage.setItem(consts.APIKEY, resp.data.access)
			if (method === "GET") {
				setTimeout(() => {
					get(url, successPayload, errorPayload, resp.data.access)
				}, 200)
			} else if (method === "POST") {
				setTimeout(() => {
					post(url, data, successPayload, errorPayload, resp.data.access)
				}, 2000)
			} else if (method === "PUT") {
				setTimeout(() => {
					put(url, data, successPayload, errorPayload, resp.data.access)
				}, 200);
			} else if (method === "DELETE") {
				setTimeout(() => {
					del(url, successPayload, errorPayload, resp.data.access)
				}, 200);
			}
		})
		.catch(error => {
			window.localStorage.clear()
			var cookies = document.cookie.split(';');
			for (var i = 0; i < cookies.length; i++) {
				document.cookie = `${cookies[i]}=;expires=${new Date(0).toUTCString()}`
			}
			setTimeout(() => {
				window.location.href = '/'
			}, 500)
		})
}



function request(data, successPayload, errorPayload) {

	axios(data)
		.then(resp => {

			//Success Payload
			successPayload(resp.data)
		})
		.catch(err => {
			if (err.request) {
				switch (err.request.status) {
					case 401:
						refreshToken(data.url, data.method, data.data, successPayload, errorPayload)
						return
					default: errorPayload(err.request)
				}
			}
		})
}

export function get(url, successPayload, errorPayload = err => { }, apiKey = "") {
	const auth = apiKey !== "" ? apiKey : window.localStorage.getItem(consts.APIKEY);
	
	axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${auth}`
		}
	})
		.then(resp => {
			successPayload(resp.data)
		})
		.catch(err => {
			console.log("Request failed", err);
			if (errorPayload) {
				errorPayload(err)
			}
			if (err.request) {
				switch (err.request.status) {
					case 401:
						refreshToken(url, 'GET', {}, successPayload)
						break
					default:
						break
				}
			}

		})
}

export function post(url, data, successPayload = () => { }, errorPayload = () => { }, apiKey = "") {
	const auth = apiKey !== "" ? apiKey : window.localStorage.getItem(consts.APIKEY);
	request({
		url: url,
		data: data,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${auth}`
		}
	}, successPayload, errorPayload)
}
export function put(url, data, successPayload, errorPayload = () => { }, apiKey = "") {
	const auth = apiKey !== "" ? apiKey : window.localStorage.getItem(consts.APIKEY);
	request({
		url: url,
		data: data,
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${auth}`
		}
	}, successPayload, errorPayload)
}
export function del(url, successPayload = () => { }, errorPayload = () => { }, apiKey = "") {
	const auth = apiKey !== "" ? apiKey : window.localStorage.getItem(consts.APIKEY);
	request({
		url: url,
		method: "DELETE",
		headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${auth}`
		}
	}, successPayload, errorPayload)
}



// WEBPACK FOOTER //
// ./src/sources/api/request/index.js